import { useContext } from 'react';

import { PayoutOrdersContext } from '../context';

export const usePayoutOrdersContext = () => useContext(PayoutOrdersContext);
